import React, { useEffect, useRef } from "react";
import downloadWhite from "images/downloadWhite.svg";
import { Button } from "@material-ui/core";
import Table from "./Table";
import "../../../style.css";
import SearchIcon from "@material-ui/icons/Search";
import { InputAdornment } from "@material-ui/core";
import { CustomTextField } from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadExcelDownloadReport,
  getDownloadReportData,
  setSearchStr,
} from "../../action";
import { errorToastMessage } from "utils/errorToast";

const DownloadReport = (props) => {
  const dispatch = useDispatch();
  const debounceTimeout = useRef(null);

  const { searchStr, recoSelection } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const { selectedGstin } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  const { downloadReportTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );
  const handleDownload = () => {
    console.log('downloadReportTableData in handleDownload::',downloadReportTableData)
    if (!downloadReportTableData || downloadReportTableData.length === 0) {
      return errorToastMessage("No data available for download");
    }
    dispatch(downloadExcelDownloadReport(downloadReportTableData));
  };
  // const handleInputChange = (event) => {
  //   const value = event.target.value;
  //   dispatch(setSearchStr(value));
  //   if (debounceTimeout.current) {
  //     clearTimeout(debounceTimeout.current);
  //   }
  //   debounceTimeout.current = setTimeout(() => {
  //     dispatch(getDownloadReportData(selectedGstin, recoSelection, value, false));
  //   }, 500);
  // };
 
 useEffect(()=>{
  props.handleSubmit(false)
 },[])
  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {/* <div style={{ width: "35%", marginTop: "1em" }}>
          <CustomTextField
            style={{ backgroundColor: "white" }}
            placeholder="Search"
            className="custom-search-field"
            variant="outlined"
            size="small"
            onChange={handleInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div> */}
        {/* <Button
          onClick={() => handleDownload()}
          type="submit"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            marginTop: "1.6em",
            marginLeft: "1em",
            height: "32px",
            fontSize: "12px",
            textTransform: "capitalize",
          }}
        >
          <img
            src={downloadWhite}
            alt="Download"
            style={{
              width: "30px",
              height: "20px",
              paddingBottom: "3px",
            }}
          />
        </Button> */}
      </div>
      <Table />
    </>
  );
};

export default DownloadReport;
